import { CoCotizacionServicio } from './../../cotizacion/servicio/cotizacion.service';
import { CoVendedorServicio } from './../../covendedor/servicio/covendedor.service';
import { FiltroCoCobranza } from './../dominio/FiltroCoCobranza';
import { CoCobranzaServicio } from './../service/cocobranza.service';
import { DtoCobranza } from './../dominio/DtoCobranza';
import { Component, OnInit, ViewChild, ChangeDetectorRef, ViewChildren, AfterContentChecked, Testability, ɵConsole } from '@angular/core';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { MessageService, ConfirmationService } from 'primeng/api';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import {  SelectItem, LazyLoadEvent } from 'primeng/primeng';
import { MaMiscelaneosdetalleServicio } from 'src/app/erp/core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { PersonamastSelectorComponent } from 'src/app/erp/core/personamast/vista/selector/personamastselector.component';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { Router } from '@angular/router';
import { PersonamastServicio } from '../../../core/personamast/service/personamast.service';
import { Table } from 'primeng/table';

@Component({
    templateUrl: './cobranza-listado.component.html'
})

export class CoCobranzaListado extends PrincipalBaseComponent implements OnInit {

    PG_DOCUMENTOS_LISTAR: number = 0;
    PG_REALIZAR_COBRANZA: number = 1;
    PG_REALIZAR_COBRANZA_PAGO: number = 2;
    PG_CLIENTE_SELECTOR: number = 3;

    lstVendedor: SelectItem[] = [];

    PG_ACTUAL: number = 0;

    @ViewChild(Table,{static:false}) dt: Table;
    @ViewChild(PersonamastSelectorComponent,{static:false}) personamastSelectorComponent: PersonamastSelectorComponent;

    lstEstados: SelectItem[] = [];
    filtro: FiltroCoCobranza = new FiltroCoCobranza();
    seleccionado: any;
    cargando: boolean = true;
    filtrofechas: Boolean = true;
    lstClientes: any[];
    dtoPersonamast: DtoPersonamast = new DtoPersonamast();

    constructor(
        private router: Router,
        private coCotizacionServicio: CoCotizacionServicio,
        private coVendedorServicio: CoVendedorServicio,
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private cdref: ChangeDetectorRef,
        private personamastServicio: PersonamastServicio,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService
    ) { super(noAuthorizationInterceptor, messageService); }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit() {
        super.ngOnInit();
        this.cargarEstados();
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        this.filtro.fechaco = firstDay;
        this.filtro.fechavenc = lastDay;
        //this.buscar();
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    filterClienteSingle(event) {
        let query = event.query;
        this.personamastServicio.listarClientes(query).then(
            res => {
                this.lstClientes = res;
            }
        );
    }

    captureId(event: any) {
        this.dtoPersonamast.persona = event.persona;
    }

    cargarEstados() {
        this.bloquearPagina();
        this.lstEstados.push({ label: 'TODO ESTADO', value: null });
        this.maMiscelaneosdetalleServicio.listarPorCabecera("CO", "999999", "COTIEST").then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstados.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                );
                this.cargando = false;
                this.desbloquearPagina();
            }
        );

        this.lstVendedor.push({ label: 'TODO VENDEDOR', value: null });
        this.coVendedorServicio.listarActivosDto().then(
            vendedores => {
                vendedores.forEach(
                    vendedor => {
                        this.lstVendedor.push({ label: vendedor.vendedorNombre, value: vendedor.vendedor });
                    }
                );
                this.desbloquearPagina();
            }
        );

    }

    toggleVisibility(e) {
        if (e) {
            this.filtro.fechaco = new Date();
            this.filtro.fechavenc = new Date();
        } else {
            this.filtro.fechaco = null;
            this.filtro.fechavenc = null;
        }
    }

    cancelarAccionSelector() {
        this.cargando = true;
        this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
    }

    cargarPaginacion(event: LazyLoadEvent) {

        if (this.cargando) {
            return;
        }

        this.bloquearPagina();

        if (this.filtrofechas === false) {
            this.filtro.fechaco = null;
            this.filtro.fechavenc = null;

            if (this.filtro.fechaco != null && this.filtro.fechavenc != null) {
                if (this.filtro.fechaco > this.filtro.fechavenc) {
                    this.mostrarMensajeAdvertencia('La fecha de Vencimiento debe se mayor o igual que la fecha de Documento');
                    this.desbloquearPagina();
                    return;
                }
            }
        }

        this.filtro.clientenum = this.dtoPersonamast.persona;
        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;

        this.coCotizacionServicio.listarCobranzaPaginacion(this.filtro)
            .then(res => {
                this.filtro.paginacion = res;
                this.desbloquearPagina();
            });
    }

    buscar() {
        if (this.filtrofechas === false) {
            if (this.estaVacio(this.dtoPersonamast.persona) && this.estaVacio(this.filtro.numerocobranza)) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de Cobranza');
                return;
            } else if (this.dtoPersonamast.persona === undefined && this.filtro.numerocobranza === undefined) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de Cobranza');
                return;
            }
        }
        this.cargando = false;
        this.dt.reset();
    }

    editar(bean: DtoCobranza) {
        this.router.navigate(['/royal/codocumentocobrar-listado', 'EDITAR', JSON.stringify(bean)], { skipLocationChange: true });
    }

    ver(bean: DtoCobranza) {
        this.router.navigate(['/royal/codocumentocobrar-listado', 'VER', JSON.stringify(bean)], { skipLocationChange: true });
    }

    mostrarSelectorCliente() {
        this.personamastSelectorComponent.iniciarComponente();
        this.PG_ACTUAL = this.PG_CLIENTE_SELECTOR;
    }

    limpiarCliente() {
        this.dtoPersonamast = new DtoPersonamast()
    }

    cotizacion: DtoCobranza = new DtoCobranza();


    nuevo() {
        this.router.navigate(['/royal/cliente-listado'], { skipLocationChange: true });
    }


}





